import {
    css, Theme,
} from '@emotion/react'

const styles = (theme: Theme) => {
    return {
        formControlStyle: css`
            margin-left: ${theme.spacing(-0.625)};
            cursor: text;
        `,
        icon: css`
            width: 24px;
            height: 24px;
            padding: 9px;
            color: ${theme.palette.primary[400]};
        `,
        summaryView: css`
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
        `,
        notSelectedText: css`
            & .MuiFormControlLabel-label {
              text-decoration: line-through;
              color: ${theme.palette.secondary.main};
            }
        `,
        itemLabel: css`
            & .MuiFormControlLabel-label {
              font-size: ${theme.typography.h3.fontSize}px;
              line-height: ${theme.typography.h3.lineHeight};
            }
        `,
    }
}

export default styles
